<template>
    <div class="c-event_cal" :class="{ 'c-event_cal--loading' : isLoading }">
        <full-calendar
            ref="calendar"
            v-if="config.contentHeight"
            class="c-event_cal__calendar"
            :event-sources="eventSources"
            :events="compEvents"
            :config="config">
        </full-calendar>
    </div>

</template>

<script>

import {mapGetters} from 'vuex'
import store from 'Store'
import moment from 'moment'
import {FullCalendar} from 'vue-full-calendar'
import 'fullcalendar/dist/locale/pl'

export default {

    name: 'EventCalendar',

    data() {
        return {
            config: {
                locale: 'pl',
                contentHeight: 0,
                allDaySlot: false,
                header: {
                    left: 'today',
                    center: '',
                    right: 'prev,title,next',
                },
                defaultView: 'listWeek',
                slotLabelFormat: [
                    'MMMM YYYY',
                    'dd',
                    'HH:mm'
                ],
                buttonText: {
                    today: 'Idź do ' + moment().format('DD MMM YYYY')
                },
                businessHours:
                    {
                        start: '00:00',
                        end: '24:00',
                        dow: [1, 2, 3, 4, 5]
                    },
                loading: this.loading
            },
            isLoading: true,
            eventSources: [
                {
                    events(start, end, timezone, callback) {
                        store.dispatch('EVENTS_FETCH', {
                            start: moment(start).format('YYYY-MM-DD'),
                            end: moment(end).format('YYYY-MM-DD'),
                            has_visit: '0',
                            with: 'patient'
                        }).then(() => {
                            callback([])
                        })
                    }
                }
            ]
        }
    },

    computed: {
        ...mapGetters(['events']),
        compEvents() {
            var _events = []
            for (let i = 0; i < this.events.length; i++) {
                let event = this.events[i]
                _events.push({
                    id: event.id,
                    start: event.start,
                    end: event.end,
                    title: event.patient.first_name + ' ' + event.patient.last_name,
                    color: this.getEventColor(event),
                    editable: false
                })
            }
            return _events
        },

    },

    methods: {
        loading(isLoading, view) {
            this.isLoading = isLoading
        },
        getEventColor(event) {
            if (event.visit_id !== null) return '#cfcfd3'
            if (event.type === 'mobile') return '#1A173B'
            return '#56BC6F'
        }
    },

    mounted() {
        this.$store.dispatch('EVENTS_RESET')
        this.$nextTick(() => {
            var toolbarHeight = 75;
            var height = this.$el.clientHeight - toolbarHeight
            this.config.contentHeight = (height < 400) ? 400 : height
        })
    },

    components: {
        FullCalendar
    }

}

</script>

<style lang="scss">

@import '~Style/_utils.scss';

.c-event_cal {
    .fc-list-item {
        cursor: context-menu;
    }
    .fc-header-toolbar .fc-right > div {
        display: flex;
    }
    .fc-view-container {
        overflow: auto;
        position: relative;

        &:before,
        &:after {
            content: '';
            position: absolute;
            opacity: 0;
            visibility: hidden;
            transition: opacity .15s ease-in-out, visibility 0s .15s linear;
        }
        &:before {
            top: 0;
            left: 0;
            width: calc(100% - 1px);
            height: 100%;
            background-color: $c-white;
            z-index: 4;
        }
        &:after {
            top: calc(50% - 25px);
            left: calc(50% - 25px);
            width: 50px;
            height: 50px;
            z-index: 5;
            background-color: $c-primary;
            border-radius: 100%;
            animation: calendar-loader 1.0s infinite ease-in-out;

            @keyframes calendar-loader {
                0% {
                    transform: scale(0);
                }
                100% {
                    transform: scale(1.0);
                    opacity: 0;
                }
            }
        }
    }
    &--loading .fc-view-container {
        &:before,
        &:after {
            visibility: visible;
            transition-delay: 0s;
            opacity: 0.9;
        }
    }
    @include bp($screen-md) {
        font-size: 13px;
    }
}

</style>
